import http from '@axios'

const resource = '/api'

export default {
  allowNotification(token) {
    return http.post(`${resource}/allow-notification/`, { token })
  },
}
